import { render, staticRenderFns } from "./ManageProductSubcategoriesModal.vue?vue&type=template&id=e01436e6&scoped=true"
import script from "./ManageProductSubcategoriesModal.vue?vue&type=script&lang=js"
export * from "./ManageProductSubcategoriesModal.vue?vue&type=script&lang=js"
import style0 from "./ManageProductSubcategoriesModal.vue?vue&type=style&index=0&id=e01436e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01436e6",
  null
  
)

export default component.exports